import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06063a31"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabButton = _resolveComponent("TabButton")!
  const _component_TabGroup = _resolveComponent("TabGroup")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Card = _resolveComponent("Card")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_Fieldset, { label: "パーツ" }, {
            default: _withCtx(() => [
              _createVNode(_component_Space, {
                vertical: "",
                large: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TabGroup, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parts.categories, (category) => {
                        return (_openBlock(), _createBlock(_component_TabButton, {
                          key: category.value,
                          modelValue: _ctx.tab,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                          name: category.label,
                          value: category.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(category.label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "name", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Space, { small: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parts[_ctx.tab], (p) => {
                        return (_openBlock(), _createBlock(_component_ToggleButton, {
                          key: p,
                          modelValue: _ctx.conf[_ctx.tab],
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.conf[_ctx.tab]) = $event)),
                          name: "パーツ",
                          size: "part",
                          value: p
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              class: "img",
                              src: p
                            }, null, 8 /* PROPS */, _hoisted_1)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}